// extracted by mini-css-extract-plugin
module.exports = {"articles":"Section3Cards_articles__1iBt6","article":"Section3Cards_article__wH1aE"};